import * as React from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { Grid } from "@mui/material";
import {
  addVehicleChecklist,
  updateVehicleChecklist,
} from "../../service/vehicleChecklistService";
import { RadioButton } from "primereact/radiobutton";

export default function VehicleChecklistView(modalProps: any) {
  const record = modalProps?.record;

  const vehicle = modalProps?.record_id;

  async function Add() {
    let updateDetails: any = {
      question: question,
      vehicle: vehicle,
      type: type,
    };
    modalProps.setGlobalLoading(true);
    if (record?.id) {
      updateVehicleChecklist(updateDetails, record.id).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Vehicle Checklist Updated Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    } else {
      addVehicleChecklist(updateDetails).then((r: any) => {
        modalProps.setGlobalLoading(false);
        modalProps.toast.current.show({
          severity: "success",
          summary: "Vehicle Checklist Added Successfully",
          life: 3000,
        });
        modalProps.setReload(!modalProps.reload);
        modalProps.setVisible(false);
      });
    }
  }

  const [question, setQuestion] = React.useState(record?.question || "");
  const [type, setType] = React.useState(record?.type || "Safe");

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl>
            <FormLabel>Question</FormLabel>
            <FormControl
              sx={{
                display: { sm: "flex-column", md: "flex-row" },
                gap: 2,
              }}
            >
              <InputTextarea
                value={question}
                placeholder="Question"
                onChange={(e) => setQuestion(e.target.value)}
              />
            </FormControl>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl>
            <FormLabel>Type</FormLabel>
            <FormControl
              sx={{
                display: { sm: "flex-column", md: "flex-row" },
                gap: 2,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <RadioButton
                    inputId="typeSafe"
                    name="Safe"
                    value="Safe"
                    onChange={(e) => setType(e.value)}
                    checked={type === "Safe"}
                  />
                  <label
                    htmlFor="typeSafe"
                    className="ml-2"
                    style={{ marginRight: 20 }}
                  >
                    Safe
                  </label>
                  <RadioButton
                    inputId="typeRisk"
                    name="Risk"
                    value="Risk"
                    onChange={(e) => setType(e.value)}
                    checked={type === "Risk"}
                  />
                  <label htmlFor="typeRisk" className="ml-2">
                    Risk
                  </label>
                </Grid>
              </Grid>
            </FormControl>
          </FormControl>
        </Grid>
      </Grid>
      <br />
      <br />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => Add()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
